import { select, scaleLinear, stack, area, extent, curveStepAfter } from 'd3'

const getNamesOfPatterns = events => {
    let names = []
    events.map(e => {
        Object.keys(e).map(f => (f !== 'timestamp' && f !== 'depth' && names.indexOf(f) === -1 ? names.push(f) : null))
    })
    return names
}

const fillEventsWithAllPatterns = (events, patternsNames) => {
    let lithologyFilled = []
    events.map((e, i) => {
        lithologyFilled.push(e)
        patternsNames.map(f => {
            if (Object.keys(e).indexOf(f) === -1) {
                lithologyFilled[i][f] = 0
            }
        })
    })
    return lithologyFilled
}

const selectColor = (key, svgDefs) => {
    switch (key) {
        case '_Water':
            return '#129a96'
        case 'OLEO':
            return '#8768a3'
        case 'MST':
            return '#6dba52'
        case 'MUD':
            return '#5a5da4'
        case 'PAC':
            return '#906545'
        case 'LDA':
            return '#3b5681'
        default:
            settingPattern(key, svgDefs)
            return 'url(#' + key + ')' //'url("/content/plugin-liverig/rocks/litologia_' + key + ".png)"
    }
}

const settingPattern = (key, svgDefs) =>
    svgDefs
        .append('pattern')
        .attr('id', key)
        .attr('width', 54)
        .attr('height', 54)
        .attr('x', 0)
        .attr('y', 0)
        .attr('patternUnits', 'userSpaceOnUse')
        .append('image')
        .attr('preserveAspectRatio', 'none')
        .attr('x', 0)
        .attr('y', 0)
        .attr('href', '/content/plugin-liverig/rocks/litologia_' + key + '.png')

export const lithologyFunction = (lithology, range, chartRefCurrent) => {
    let names = getNamesOfPatterns(lithology)
    let lithologyFilled = fillEventsWithAllPatterns(lithology, names)

    var margin = { top: 0, right: 0, bottom: 0, left: 0 },
        width = 20 - margin.left - margin.right,
        height = 613 - margin.top - margin.bottom

    select(chartRefCurrent)
        .selectAll('.lithology-chart')
        .remove()

    select(chartRefCurrent)
        .selectAll('defs')
        .remove()

    var svgDefs = select(chartRefCurrent).append('defs')

    var svg = select(chartRefCurrent)
        .append('svg')
        .attr('class', 'lithology-chart')
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .style('transform', 'rotate(90deg)translateY(-20px)')

    var x = scaleLinear()
        .domain(range?.length === 2 && range ? range : extent(lithologyFilled, d => d.depth))
        .range([0, height])

    var y = scaleLinear()
        .domain([0, 100])
        .range([width, 0])

    var stackedData = stack().keys(names)(lithologyFilled)

    svg.selectAll('layers')
        .data(stackedData)
        .enter()
        .append('path')
        .attr('class', d => d.key)
        .style('fill', d => selectColor(d.key, svgDefs))
        .attr(
            'd',
            area()
                .curve(curveStepAfter)
                .x(d => x(d.data.depth))
                .y0(d => y(d[0]))
                .y1(d => y(d[1]))
        )
}
